import { ViewListIcon } from "../Icons";

export default function ListMetaRow({ showIcons, displayDates, date, wrapperStyle, spacingTop = "0.75rem", showLabel = true }) {
    return (
        <div style={{ display: "flex", justifyContent: "space-between", ...wrapperStyle }}>
            <div style={{ display: showIcons ? "flex" : "none", alignItems: "center" }}>
                <ViewListIcon style={{ marginRight: "0.5rem", marginTop: spacingTop }} />
                {showLabel && (
                    <p style={{ fontSize: "28px", fontWeight: "500", margin: 0, zIndex: 20, display: "block", width: "100%", marginTop: spacingTop }}>View List</p>
                )}
            </div>
            <div style={{ display: displayDates ? "flex" : "none", zIndex: 20, minWidth: "30%", textAlign: showIcons ? "right" : "left" }}>
                <p style={{ fontWeight: "500", fontSize: "28px", margin: 0, display: "block", width: "100%", marginTop: spacingTop }}>{date}</p>
            </div>
        </div>
    );
}
